import { jsx } from 'react/jsx-runtime';
import React__default, { useState, useImperativeHandle, useCallback } from 'react';
import AuthCode from 'react-auth-code-input';
import classNames from 'classnames';

const CodeInput = /*#__PURE__*/ React__default.forwardRef(({ onComplete, onChange, length = 6, className, ...props }, ref)=>{
    const [key, setKey] = useState(0);
    /**
     * Pass Helpers to Ref.
     */ useImperativeHandle(ref, ()=>({
            reset
        }));
    /**
     * Reset Code Input.
     */ const reset = ()=>{
        setKey((key)=>key + 1);
    };
    /**
     * Handle Change.
     */ const handleChange = useCallback((code)=>{
        // Call onComplete when code match input length.
        if (code.length === length) {
            onComplete?.(code, reset);
        }
        // Call original onChange.
        onChange?.(code);
    }, [
        length,
        onChange,
        onComplete
    ]);
    return jsx("div", {
        className: classNames('cb-code-input', className),
        "data-testid": "code-input",
        children: jsx(AuthCode, {
            containerClassName: "code-input-container",
            length: length,
            onChange: handleChange,
            ...props
        }, key)
    });
});
CodeInput.displayName = 'CodeInput';

export { CodeInput, CodeInput as default };
//# sourceMappingURL=CodeInput.es.js.map
